import PropTypes from 'prop-types';
import Carousel from '@skeletons/Carousel/Carousel';
import CourseCard from './CourseCard';

const CourseCarousel = ({ number, gridColumn }) => (
  <Carousel number={number} gridColumn={gridColumn}>
    {new Array(number).fill(0).map((val, index) => (
      <CourseCard key={String(index)} />
    ))}
  </Carousel>
);

CourseCarousel.propTypes = {
  number: PropTypes.number,
  gridColumn: PropTypes.string
};

CourseCarousel.defaultProps = {
  number: 3,
  gridColumn: 'span 18'
};

export default CourseCarousel;
